// Aggregates every admin-area i18n fragment into a single { vi, en } object.
// Each fragment is `{ vi: {...}, en: {...} }` with full key parity.
// Merged into the main dictionary by ../dictionary.js.
import Admin from './Admin';
import Comments from './Comments';
import CommentExtras from './CommentExtras';
import Composer from './Composer';
import Facebook from './Facebook';
import FacebookPost from './FacebookPost';
import GoogleAndSettings from './GoogleAndSettings';
import Guide from './Guide';
import Pinterest from './Pinterest';
import PinterestPost from './PinterestPost';
import ScrapboxTelegraph from './ScrapboxTelegraph';
import TelegramBot from './TelegramBot';
import Tiktok from './Tiktok';
import X from './X';
import Youtube1 from './Youtube1';
import Youtube2 from './Youtube2';
import Nav from './Nav';
import Sync from './Sync';
import PlatformTabs from './PlatformTabs';

const fragments = [
  Admin,
  Comments,
  CommentExtras,
  Composer,
  Sync,
  PlatformTabs,
  Facebook,
  FacebookPost,
  GoogleAndSettings,
  Guide,
  Pinterest,
  PinterestPost,
  ScrapboxTelegraph,
  TelegramBot,
  Tiktok,
  X,
  Youtube1,
  Youtube2,
  Nav,
];

const adminDictionary = fragments.reduce(
  (acc, frag) => {
    Object.assign(acc.vi, frag.vi);
    Object.assign(acc.en, frag.en);
    return acc;
  },
  { vi: {}, en: {} }
);

export default adminDictionary;
